import { useTranslation } from 'react-i18next';
import { File } from 'lucide-react';

import { HelpDeskTicketDetail } from 'services/help-desk/type';
import { ScrollArea } from 'components/ui/scroll-area';
import { getDateTime } from 'lib/utils';
interface DetailsProps {
  ticketDetails: HelpDeskTicketDetail;
}

function Details({ ticketDetails }: DetailsProps) {
  const { t } = useTranslation();

  return (
    <div className='col-span-1 px-4 mt-4'>
      <ScrollArea className='space-y-4 h-[calc(100vh-13rem)]'>
        <div>
          <p className='text-md'>{t('issue_title')}</p>
          <p className='px-4 py-2 text-sm border-2 border-primary/40 rounded-xl'>
            {ticketDetails?.ticket_detail?.[0]?.subject}{' '}
          </p>
        </div>
        <div>
          <p className='text-md'>{t('description')}</p>
          <p className='px-4 py-2 text-sm border-2 border-primary/40 rounded-xl'>
            {ticketDetails?.ticket_detail?.[0]?.description}
          </p>
        </div>
        <div>
          <p className='text-md'>{t('priority')}</p>
          <p className='px-4 py-2 text-sm capitalize border-2 border-primary/40 rounded-xl'>
            {ticketDetails?.ticket_detail?.[0]?.priority}
          </p>
        </div>
        <div>
          <p className='text-md'>{t('created_on')}</p>
          <p className='px-4 py-2 text-sm border-2 border-primary/40 rounded-xl'>
            {
              getDateTime(
                ticketDetails?.ticket_detail?.[0]?.created_at,
                'dd/MM/yyyy'
              ).date
            }
          </p>
        </div>
        <div>
          <p className='text-md'>{t('last_updated_on')}</p>
          <p className='px-4 py-2 text-sm border-2 border-primary/40 rounded-xl'>
            {
              getDateTime(
                ticketDetails?.ticket_detail?.[0]?.lastmodified_at || '',
                'dd/MM/yyyy'
              ).date
            }
          </p>
        </div>
        {ticketDetails?.attachment_detail.length ? (
          <div>
            <p className='text-md'>{t('attachments')}</p>
            <p className='flex flex-wrap items-center justify-start gap-2 px-2 py-2 border-2 border-primary/40 rounded-xl'>
              <>
                {ticketDetails?.attachment_detail?.map(
                  (item: any, index: number) => (
                    <span
                      key={index}
                      className='flex items-center justify-start gap-2 px-2 text-sm border-2 rounded-md bg-primary/10 text-primary'
                    >
                      <File className='w-4 h-4 text-bold' fill='#3177DC' />
                      <a href={item?.attachment_link} target='_blank'>
                        {item.attachment_id.split('-').pop()}
                      </a>
                    </span>
                  )
                )}
              </>
            </p>
          </div>
        ) : null}
      </ScrollArea>
    </div>
  );
}

export default Details;
